<template>
    <svg :width="width" :height="height" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.1667 21.5625H2.83333C2.04974 21.5625 1.41667 20.9201 1.41667 20.125V2.875C1.41667 2.07988 2.04974 1.4375 2.83333 1.4375H8.5V6.46875C8.5 7.65918 9.45182 8.625 10.625 8.625H15.5833V20.125C15.5833 20.9201 14.9503 21.5625 14.1667 21.5625ZM10.625 7.1875C10.2354 7.1875 9.91667 6.86406 9.91667 6.46875V1.45996C10.0406 1.49141 10.1557 1.5543 10.2443 1.64863L15.3753 6.85508C15.4682 6.94941 15.5302 7.06172 15.5612 7.1875H10.625ZM2.83333 0C1.27057 0 0 1.28926 0 2.875V20.125C0 21.7107 1.27057 23 2.83333 23H14.1667C15.7294 23 17 21.7107 17 20.125V7.3627C17 6.79219 16.7742 6.24414 16.3758 5.83984L11.2492 0.633398C10.8508 0.229102 10.3107 0 9.74844 0H2.83333ZM4.25 17.25H7.79167V18.6875H4.25V17.25ZM4.25 15.8125V14.375H7.79167V15.8125H4.25ZM9.20833 18.6875V17.25H12.75V18.6875H9.20833ZM9.20833 15.8125V14.375H12.75V15.8125H9.20833ZM14.1667 16.5312V15.8125V14.375V13.6562V12.9375V11.5C14.1667 10.7049 13.5336 10.0625 12.75 10.0625H8.5H4.25C3.46641 10.0625 2.83333 10.7049 2.83333 11.5V12.9375V13.6562V14.375V15.8125V16.5312V17.25V18.6875C2.83333 19.4826 3.46641 20.125 4.25 20.125H7.79167H8.5H9.20833H12.75C13.5336 20.125 14.1667 19.4826 14.1667 18.6875V17.25V16.5312ZM12.75 11.5V12.9375H8.5H4.25V11.5H8.5H12.75Z" fill="white"/>
    </svg>
</template>
<script>
    export default {
        name: 'ui-spreadsheet',
        props: {
            design: {
                type: String,
                default: ''
            },
            fill: {
                type: String,
                default: '#FFF'
            },
            width: {
                type: [String, Number],
                default: 17
            },
            height: {
                type: [String, Number],
                default: 23
            }
        }
    }
</script>